import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import InBodyHistorySearchBar from '@icoach/inbody/history/InBodyHistorySearchBar';
import InBodyHistoryTable from '@icoach/inbody/history/InBodyHistoryTable';
import InBodyVisitorsDialog from '@icoach/inbody/history/InBodyVisitorsDialog';
import { Box, Typography } from "@curves/ui-base";
import { InBodyProvider } from '@icoach/inbody/components/InBodyContext';
import InbodyUploadExcel from '@icoach/inbody/components/InbodyUploadExcel';

// 量身記錄
const InBodyHistoryPage = React.forwardRef((props, ref) => {
	const { referenceID } = useParams();
	const [sourceData, setSourceData] = useState([]);
	const [isShowContent, setShowContent] = useState(false);

	const inbodyValue = {
		sourceData: sourceData,
		setSourceData: target => {
			setSourceData(target);
		},
        setShowContent: isShow => setShowContent(isShow),
		referenceID: referenceID
	};

	const SearchBar = useMemo(
		() => {
			return <InBodyHistorySearchBar className="mb-4" />
		},
		// eslint-disable-next-line
		[referenceID]
	);

	return (
		<InBodyProvider value={inbodyValue}>
			<Box className="container main-container-spacing">
				<Box component="header" className="page-header">
					<Typography className="page-header-title" variant="h3">
						量身紀錄
					</Typography>
					<Box className="btn-group">
						<InbodyUploadExcel />
						<InBodyVisitorsDialog />
					</Box>
				</Box>
				{SearchBar}
				{isShowContent && <InBodyHistoryTable />}
			</Box>
		</InBodyProvider>
	);
});

export default InBodyHistoryPage;
